import { SearchOutlined } from '@ant-design/icons'
import { Button, Col, Form, Input, Row } from 'antd'
import { useTranslation } from 'react-i18next'
import SelectVeterinaryProductCategory from '../../../../../components/selects/SelectVeterinaryProductCategory'

interface IProps {
	formField: any
	form: any
	onReset: () => void
	onSearch: () => void
}

export const FilterTypeVeterinaryProduct = (props: IProps) => {
	const { t } = useTranslation()

	return (
		<Form form={props.form} layout='vertical'>
			<Row gutter={10}>
				<Col span={6}>
					<Form.Item label={t('general.name')} name={props.formField.name}>
						<Input autoComplete='off' />
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item
						label={t('mechanisation.transport.category')}
						name={props.formField.categoryId}
					>
						<SelectVeterinaryProductCategory />
					</Form.Item>
				</Col>
				<Col span={6}>
					<div style={{ marginTop: 30 }}>
						<Button
							type='primary'
							shape='default'
							size='middle'
							icon={<SearchOutlined />}
							style={{ marginRight: 'auto' }}
							onClick={props.onSearch}
						>
							{t('general.search')}
						</Button>
						<Button size='small' type='link' onClick={props.onReset} style={{ color: 'orange' }}>
							{t('general.reset')}
						</Button>
					</div>
				</Col>
			</Row>
		</Form>
	)
}
